module.exports = __webpack_public_path__ + "static/media/alone-floor.081c0ed4.svg";